import { useNavigate, useOutletContext } from 'react-router-dom'

import { ProfileIndexPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import ContractVersionsPage from 'modules/contracts/pages/ContractVersionsPage'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type Employee from 'modules/employees/store/models/Employee'

const IndexPage = () => {
  const { navigation } = useNavigation()

  const { employee } = useOutletContext<{
    employee: Employee
    contractVersion: ContractVersion | null | undefined
  }>()

  const navigate = useNavigate()

  const { data } = useQuery(ProfileIndexPageDocument, {
    variables: {
      employeeId: employee.id,
    },
  })
  const canSeeContract = data?.employees.employee?._policies?.seeContract.can ?? false

  if (canSeeContract) {
    return <ContractVersionsPage />
  }

  navigate(navigation.profile.fullPath())

  return null
}

export default IndexPage
